<div class="ui-g ui-fluid clear-ui">
    <div class="ui-g-12">
        <h1 class="card__title--h1 color--white layout-page-title">Users</h1>
    </div>
    <div class="ui-g-12 ui-xl-6">
        <div class="card p-p-0">
            <p-table #tableUsers [columns]="cols" [value]="users" selectionMode="single" dataKey="id"
                [(selection)]="selectedUser" [paginator]="true" [rows]="10" [scrollable]="true"
                paginatorPosition="bottom"  styleClass="p-datatable-striped">
                <ng-template pTemplate="caption">
                    <div class="ui-helper-clearfix p-text-left">
                        <button icon="ui-icon-add" label="New" pButton (click)="createUser()"></button>
                        <!-- <button pButton icon="ui-icon-cloud-download" iconPos="left" label="Download CSV"
                            (click)="tableUsers.exportCSV()"></button> -->
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                        <th class="p-text-right">
                            Actions
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData" (dblclick)="viewUser(rowData)">

                        <td *ngFor="let col of columns">
                            {{rowData[col.field]}}
                        </td>
                        <td class="p-text-right">
                            <button class="ui-button-information ui-button__center" pButton
                                (click)="viewUser(rowData)" [disabled]="isDisabled"  pTooltip="Edit" tooltipPosition="top"
                                icon="ui-icon-edit" ></button>
                            <button class="ui-button-information ui-button__center" pButton
                                (click)="deleteUser(rowData)" [disabled]="isDisabled" pTooltip="Delete" tooltipPosition="top"
                                icon="ui-icon-delete"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
